var render = function render() {
  var _vm$currentNode$attri
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.isLoading
    ? _c("div", [_c("studip-progress-indicator")], 1)
    : _c(
        "article",
        {
          staticClass: "studip-tree-table",
        },
        [
          _c(
            "header",
            [
              _vm.currentNode.id !== "root"
                ? _c("tree-breadcrumb", {
                    attrs: {
                      node: _vm.currentNode,
                      icon: _vm.breadcrumbIcon,
                      editable: _vm.editable,
                      "edit-url": _vm.editUrl,
                      "create-url": _vm.createUrl,
                      "delete-url": _vm.deleteUrl,
                      "show-navigation": _vm.showStructureAsNavigation,
                      "num-children": _vm.children.length,
                      "num-courses": _vm.courses.length,
                      assignable: _vm.assignable,
                      "visible-children-only": _vm.visibleChildrenOnly,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.withChildren && !_vm.currentNode.attributes["has-children"]
            ? _c(
                "section",
                {
                  staticClass: "studip-tree-node-no-children",
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$gettext(
                          "Auf dieser Ebene existieren keine weiteren Unterebenen."
                        )
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "sr-only",
              attrs: {
                "aria-live": "assertive",
              },
            },
            [_vm._v(_vm._s(_vm.assistiveLive))]
          ),
          _vm._v(" "),
          ((_vm$currentNode$attri = _vm.currentNode.attributes.description) ===
            null || _vm$currentNode$attri === void 0
            ? void 0
            : _vm$currentNode$attri.trim()) !== ""
            ? _c("div", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.currentNode.attributes["description-formatted"]
                  ),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.thisLevelCourses === 0
            ? _c(
                "section",
                {
                  staticClass: "studip-tree-node-no-courses",
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$gettext(
                          "Auf dieser Ebene sind keine Veranstaltungen zugeordnet."
                        )
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.thisLevelCourses + _vm.subLevelsCourses > 0
            ? _c(
                "section",
                [
                  _vm.withCourses && _vm.showingAllCourses
                    ? _c("span", [
                        _c(
                          "button",
                          {
                            attrs: {
                              type: "button",
                              title: _vm.$gettext(
                                "Veranstaltungen auf dieser Ebene anzeigen"
                              ),
                            },
                            on: {
                              click: function click($event) {
                                return _vm.showAllCourses(false)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$gettext(
                                    "Veranstaltungen auf dieser Ebene anzeigen"
                                  )
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.thisLevelCourses > 0 && _vm.subLevelsCourses > 0
                    ? [_vm._v("\n            |\n        ")]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.withCourses &&
                  _vm.subLevelsCourses > 0 &&
                  !_vm.showingAllCourses
                    ? _c("span", [
                        _c(
                          "button",
                          {
                            attrs: {
                              type: "button",
                              title: _vm.$gettext(
                                "Veranstaltungen auf Unterebenen anzeigen"
                              ),
                            },
                            on: {
                              click: function click($event) {
                                return _vm.showAllCourses(true)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$gettext(
                                    "Veranstaltungen auf Unterebenen anzeigen"
                                  )
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentNode.attributes["has-children"] || _vm.courses.length > 0
            ? _c(
                "table",
                {
                  staticClass: "default",
                },
                [
                  _c(
                    "caption",
                    {
                      staticClass: "studip-tree-node-info",
                    },
                    [
                      _vm.withChildren && _vm.children.length > 0
                        ? _c("span", [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$gettextInterpolate(
                                    _vm.$gettext("%{ count } Unterebenen"),
                                    {
                                      count: _vm.children.length,
                                    }
                                  )
                                ) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.withChildren &&
                      _vm.children.length > 0 &&
                      _vm.withCourses &&
                      _vm.courses.length > 0
                        ? _c("span", [
                            _vm._v("\n                ,\n            "),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("thead", [
                    _vm.totalCourseCount > _vm.limit
                      ? _c("tr", [
                          _c(
                            "td",
                            {
                              attrs: {
                                colspan: "4",
                              },
                            },
                            [
                              _c("studip-pagination", {
                                attrs: {
                                  "items-per-page": _vm.limit,
                                  "total-items": _vm.totalCourseCount,
                                  "current-offset": _vm.offset,
                                },
                                on: {
                                  updateOffset: _vm.updateOffset,
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th"),
                      _vm._v(" "),
                      _c("th", [_vm._v(_vm._s(_vm.$gettext("Typ")))]),
                      _vm._v(" "),
                      _c("th", [_vm._v(_vm._s(_vm.$gettext("Name")))]),
                      _vm._v(" "),
                      _c("th", [_vm._v(_vm._s(_vm.$gettext("Information")))]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "draggable",
                    {
                      attrs: {
                        handle: ".drag-handle",
                        animation: 300,
                        tag: "tbody",
                        role: "listbox",
                      },
                      on: {
                        end: _vm.dropChild,
                      },
                      model: {
                        value: _vm.children,
                        callback: function callback($$v) {
                          _vm.children = $$v
                        },
                        expression: "children",
                      },
                    },
                    [
                      _vm._l(_vm.children, function (child, index) {
                        return _c(
                          "tr",
                          {
                            key: index,
                            staticClass: "studip-tree-child",
                          },
                          [
                            _c("td", [
                              _vm.editable && _vm.children.length > 1
                                ? _c(
                                    "a",
                                    {
                                      ref: "draghandle-" + index,
                                      refInFor: true,
                                      staticClass: "drag-link",
                                      attrs: {
                                        role: "option",
                                        tabindex: "0",
                                        title: _vm.$gettextInterpolate(
                                          _vm.$gettext(
                                            "Sortierelement für Element %{node}. Drücken Sie die Tasten Pfeil-nach-oben oder Pfeil-nach-unten, um dieses Element in der Liste zu verschieben."
                                          ),
                                          {
                                            node: child.attributes.name,
                                          },
                                          true
                                        ),
                                      },
                                      on: {
                                        keydown: function keydown($event) {
                                          return _vm.keyHandler($event, index)
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "drag-handle",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.nodeUrl(
                                      child.id,
                                      _vm.semester !== "all"
                                        ? _vm.semester
                                        : null
                                    ),
                                    tabindex: "0",
                                    title: _vm.$gettextInterpolate(
                                      _vm.$gettext(
                                        "Unterebene %{ node } öffnen"
                                      ),
                                      {
                                        node: _vm.node.attributes.name,
                                      },
                                      true
                                    ),
                                  },
                                  on: {
                                    click: function click($event) {
                                      $event.preventDefault()
                                      return _vm.openNode(child)
                                    },
                                  },
                                },
                                [
                                  _c("studip-icon", {
                                    attrs: {
                                      shape: child.attributes["has-children"]
                                        ? "folder-full"
                                        : "folder-empty",
                                      size: 26,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.nodeUrl(
                                      child.id,
                                      _vm.semester !== "all"
                                        ? _vm.semester
                                        : null
                                    ),
                                    tabindex: "0",
                                    title: _vm.$gettextInterpolate(
                                      _vm.$gettext(
                                        "Unterebene %{ node } öffnen"
                                      ),
                                      {
                                        node: _vm.node.attributes.name,
                                      },
                                      true
                                    ),
                                  },
                                  on: {
                                    click: function click($event) {
                                      $event.preventDefault()
                                      return _vm.openNode(child)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(child.attributes.name) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _vm.node.attributes.ancestors.length > 2
                                  ? _c("tree-node-course-info", {
                                      attrs: {
                                        node: child,
                                        semester: _vm.semester,
                                        "sem-class": _vm.semClass,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.courses, function (course) {
                        return _c(
                          "tr",
                          {
                            key: course.id,
                            staticClass: "studip-tree-child studip-tree-course",
                          },
                          [
                            _c("td"),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("studip-icon", {
                                  attrs: {
                                    shape: "seminar",
                                    size: 26,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.courseUrl(course.id),
                                    tabindex: "0",
                                    title: _vm.$gettextInterpolate(
                                      _vm.$gettext(
                                        "Zur Veranstaltung %{ title }"
                                      ),
                                      {
                                        title: course.attributes.title,
                                      },
                                      true
                                    ),
                                  },
                                },
                                [
                                  course.attributes["course-number"]
                                    ? [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              course.attributes["course-number"]
                                            ) +
                                            "\n                        "
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(course.attributes.title) +
                                      "\n                    "
                                  ),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "course-dates",
                                attrs: {
                                  id: "course-dates-" + course.id,
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                attrs: {
                                  colspan: _vm.editable ? 2 : null,
                                },
                              },
                              [
                                _c("tree-course-details", {
                                  attrs: {
                                    course: course.id,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.totalCourseCount > _vm.limit
                    ? _c("tfoot", [
                        _c("tr", [
                          _c(
                            "td",
                            {
                              attrs: {
                                colspan: "4",
                              },
                            },
                            [
                              _c("studip-pagination", {
                                attrs: {
                                  "items-per-page": _vm.limit,
                                  "total-items": _vm.totalCourseCount,
                                  "current-offset": _vm.offset,
                                },
                                on: {
                                  updateOffset: _vm.updateOffset,
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showExport
            ? _c(
                "MountingPortal",
                {
                  attrs: {
                    mountTo: "#export-widget",
                    name: "sidebar-export",
                  },
                },
                [
                  _vm.courses.length > 0
                    ? _c("tree-export-widget", {
                        attrs: {
                          title: _vm.$gettext("Download des Ergebnisses"),
                          url: _vm.exportUrl(),
                          "export-data": _vm.courses,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.withCourseAssign
            ? _c(
                "MountingPortal",
                {
                  attrs: {
                    mountTo: "#assign-widget",
                    name: "sidebar-assign-courses",
                  },
                },
                [
                  _vm.courses.length > 0
                    ? _c("assign-link-widget", {
                        attrs: {
                          node: _vm.currentNode,
                          courses: _vm.courses,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("colgroup", [
      _c("col", {
        staticStyle: {
          width: "20px",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticStyle: {
          width: "30px",
        },
      }),
      _vm._v(" "),
      _c("col"),
      _vm._v(" "),
      _c("col", {
        staticStyle: {
          width: "40%",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }